/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { HomePageEvent, useHomePageDataSelector } from "../Pages/HomePage";

export default function SecondHeader() {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [keyword, setKeyword] = useState<string>("");

  const dispatch = useDispatch();

  const pageData = useHomePageDataSelector();

  useEffect(() => {
    dispatch({
      type: HomePageEvent.GET_APP_CATEGORIES,
    });
  }, [dispatch]);

  useEffect(() => {
    const secondHeader = document.getElementById("second-header");
    const sticky = secondHeader?.offsetTop;
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 0) {
        if (sticky) {
          if (window.pageYOffset > sticky) {
            secondHeader?.classList.add("sticky");
          } else {
            secondHeader?.classList.remove("sticky");
          }
        }
      }
    });
  }, []);

  return (
    <div className="second-header" id="second-header">
      <div className="container">
        <div className="row">
          <div className="col-lg-9 mt-2">
            <ul className="second-header-menu common-list">
              <li className="second-header-menu__item">
                <NavLink
                  to="/"
                  className="second-header-menu__item-link pl-0"
                  activeClassName="active"
                >
                  All Apps
                </NavLink>
              </li>
              <li className="second-header-menu__item">
                <NavLink
                  to="/new-apps"
                  className="second-header-menu__item-link"
                  activeClassName="active"
                >
                  Newly Added Apps
                </NavLink>
              </li>
              <li className="second-header-menu__item">
                <NavLink
                  to="/top-rated-apps"
                  className="second-header-menu__item-link"
                  activeClassName="active"
                >
                  Top Rated Apps
                </NavLink>
              </li>
              <li className="second-header-menu__item">
                <NavLink
                  to="/most-used-apps"
                  className="second-header-menu__item-link"
                  activeClassName="active"
                >
                  Most Used Apps
                </NavLink>
              </li>
              <li
                className={
                  showDropdown
                    ? "second-header-menu__item dropdown show"
                    : "second-header-menu__item dropdown"
                }
              >
                <NavLink
                  className="second-header-menu__item-link dropdown-toggle"
                  activeClassName={showDropdown ? "active" : ""}
                  to="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowDropdown(!showDropdown);
                  }}
                >
                  Category <i className="fas fa-caret-down"></i>
                </NavLink>
                <div
                  className={
                    showDropdown
                      ? "dropdown-menu border-0 rounded-0 shadow show "
                      : "dropdown-menu border-0 rounded-0 shadow"
                  }
                  aria-labelledby="navbarDropdown"
                >
                  {pageData.categories &&
                    pageData.categories.map((category) => (
                      <NavLink
                        key={category.categoryName}
                        to={"/app-by-category/" + category.categoryName}
                        className="dropdown-item"
                        activeClassName="active"
                        onClick={() => {
                          setShowDropdown(!showDropdown);
                        }}
                      >
                        <i className={category.icon} />
                        {category.categoryName}
                      </NavLink>
                    ))}
                </div>
              </li>
              {sessionStorage.getItem("isAuthed") === "true" && (
                <li className="second-header-menu__item">
                  <NavLink
                    to="/my-apps"
                    className="second-header-menu__item-link"
                    activeClassName="active"
                  >
                    My Apps
                  </NavLink>
                </li>
              )}
            </ul>
          </div>
          <div className="col-lg-3">
            <div className="input-group">
              <input
                type="search"
                className="form-control border-0 bg-back"
                placeholder="Search Apps"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
              />
              <Link
                className="input-group-prepend"
                to={"/search-apps/" + keyword}
              >
                <button className="btn btn-primary">
                  <i className="fas fa-search"></i>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
